import { createSlice } from "@reduxjs/toolkit";
import { coupaFilterPayload } from "../../constData/filterRequestPayloadCoupa";

const initialState = {
  coupaTableFilter: coupaFilterPayload,
};
const drmCoupaTableFilterSlice = createSlice({
  name: "drmCoupaFilterPayload",
  initialState,
  reducers: {
    setCoupaTableFilter: (state, action) => {
      state.coupaTableFilter = {
        ...state.coupaTableFilter,
        ...action.payload,
      };
    },
    resetCoupaTableFilter: (state) => {
      state.coupaTableFilter = coupaFilterPayload;
    },
    resetCoupaColumnTableFilters: (state) => {
      state.coupaTableFilter = {
        ...state.coupaTableFilter,
        filters: {
          ...(state.coupaTableFilter?.filters || {}),
          fileNames: [],
          fileCategory: [],
          createdAt: { date: [], operator: "" },
        },
      };
    },
  },
});
export const { setCoupaTableFilter, resetCoupaTableFilter, resetCoupaColumnTableFilters } = drmCoupaTableFilterSlice.actions;
export default drmCoupaTableFilterSlice.reducer;
